<template>
    <div class="redirect">

    </div>
</template>

<script>
    import $ from 'jquery'

    export default {
        props: {

            // required
            siteId : { type: String, required : true },
            callbackUrls : { type: Array, required : true },
            
            // pixels
            fbPixelId : String,
            snapPixelId : String,
            tikTokPixelId : String,
        },
        data() {
            return {
                pixelSent: false,
                ios: true,
            }
        },
        created () {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/android/i.test(userAgent)) {
                this.ios = false;
            }

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                this.ios = true;
            }

            var viewAt = -1;
            if(this.fbPixelId != undefined){
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window,document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', this.fbPixelId); 
                fbq('track', 'PageView');
                fbq('track', 'ViewContent');
                viewAt = new Date().getTime();
            }

            if(this.snapPixelId != undefined){
              (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
              {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
              a.queue=[];var s='script';var r=t.createElement(s);r.async=!0;
              r.src=n;var u=t.getElementsByTagName(s)[0];
              u.parentNode.insertBefore(r,u);})(window,document,
              'https://sc-static.net/scevent.min.js');
              snaptr('init', this.snapPixelId);
              snaptr('track', 'PAGE_VIEW', { 'description' : this.siteId });
            }

            this.pixelSent = false;

            var camp_ios   = this.callbackUrls[0];
            var camp_android = this.callbackUrls[1];

            var params = {};
            location.search.substr(1).split("&").forEach(function(item) { params[item.split("=")[0]] = item.split("=")[1] });
            var utm_source = params.site_source_name;
            //var utm_medium = params.placement;
            var utm_campaign = params.name;
            var ad_id = params.adid;
            var site_id = params.site_id;
            var os = params.os;
            var campType = params.camp;

            if(!site_id) {
                site_id = this.siteId;
            }

            var _camp = camp_ios;
            if (os == "android") {
                _camp = camp_android;
            }
            
            var red_URL = `${_camp}?advertising_id=${ad_id}&site_id=${site_id}&ad_network=${utm_source}&campaign_name=${utm_campaign}`;

            if (this.pixelSent == false) {
                if(this.snapPixelId != undefined){
                    snaptr('track', 'ADD_CART');
                }
                if(this.fbPixelId != undefined){
                    fbq('track', 'InitiateCheckout');
                    var totalTimeToInitiate = new Date().getTime() - viewAt;
                    fbq('trackCustom', 'TimeToInitiate', {duration: totalTimeToInitiate});
                }

                this.pixelSent = true;
            }
        
            // location.href = red_URL;
        }
    }
</script>

<style lang="scss" scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/views/traffic/RedirectTenjin.vue